var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 125,
    viewBox: "0 0 126 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 0.416504C28.7301 0.416504 0.916748 28.2298 0.916748 62.4998C0.916748 96.7698 28.7301 124.583 63.0001 124.583C97.2701 124.583 125.083 96.7698 125.083 62.4998C125.083 28.2298 97.2701 0.416504 63.0001 0.416504ZM63.0001 112.166C35.6213 112.166 13.3334 89.8786 13.3334 62.4998C13.3334 35.1211 35.6213 12.8332 63.0001 12.8332C90.3788 12.8332 112.667 35.1211 112.667 62.4998C112.667 89.8786 90.3788 112.166 63.0001 112.166ZM91.4963 35.059L50.5834 75.9719L34.5038 59.9544L25.7501 68.7082L50.5834 93.5415L100.25 43.8748L91.4963 35.059Z",
    fill: "#05CD99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.80c5a9254f0e516bb7191a6ee3588232.svg";
export { ForwardRef as ReactComponent };